<template>
  <v-col>
    <v-card>
      <v-card-title>
        <v-spacer/>
        <h1>Register Dog Report Order</h1>
        <v-spacer/>
      </v-card-title>
      <v-card-text>
        <v-sheet class="mt-5" height="70vh">
        <v-alert class="mb-5 mt-1" border="left" colored-border :type="'info'">
          <v-row>
            <v-col cols="8">
              Required fields are marked with a '*'.  
            </v-col>
          </v-row>
        </v-alert>        
        <v-alert class="mb-2 mt-1" v-if="errorMessage" :type="'error'">
          {{ errorMessage }}
        </v-alert>
        <v-row>
          <v-col class="text-left">
            <v-row>
              <v-col>
                <h2>Requester *</h2>
                <v-row> 
                  <v-col>
                    <v-text-field
                      hide-details
                      v-model="memberId"
                      label="Member ID"
                      clearable
                      @click:clear="memberId = ''; selectedRequester = null"
                    />
                    <span v-if="!!selectedRequester">{{ selectedRequester.firstName }} {{ selectedRequester.lastName }} ({{selectedRequester.memberId}})</span>
                  </v-col>
                  <v-col>
                    <v-dialog v-model="peopleSearchDialog" max-width="800px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" 
                          dark dense class="mb-2"
                          v-bind="attrs"
                          v-on:click="peopleSearchDialog = true">
                          Find member
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="text-h5">Find member</span>
                        </v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col>
                              <v-text-field class="form-text"
                                outlined dense
                                v-model="memberId"
                                label="Member ID" />                                
                            </v-col>
                            <v-col>
                              <v-text-field class="form-text"
                                outlined dense
                                v-model="memberName"
                                label="Member name" />                                
                            </v-col>
                            <v-col>
                              <v-btn class="ml-1 text-xs" v-on:click="findPerson" color="primary">
                                <v-icon> mdi-magnify </v-icon>
                                  Search
                                </v-btn>                               
                            </v-col>
                          </v-row> 
                          <p v-if="searchPeopleResults.length == 0 && hasSearched">
                              No Matches Found
                          </p>                          
                          <v-data-table v-if="searchPeopleResults.length > 0"
                                        :headers="searchPeopleHeaders"
                                        :items="searchPeopleResults"
                                        hide-default-footer>

                              <template v-slot:item="row">
                                  <tr>
                                      <td>
                                          <a :href="`/admin/people/${row.item.personId}`" target="_blank">
                                              {{row.item.memberId}}
                                          </a>

                                      </td>
                                      <td>
                                          <a :href="`/admin/people/${row.item.personId}`" target="_blank">
                                              {{ row.item.name }}
                                          </a>
                                      </td>
                                      <td>
                                          <font-awesome-icon icon="id-card" :color="row.item.isActiveMember == false ? 'red' : 'green'" />
                                      </td>
                                      <td>
                                          <v-btn class="ml-1 mr-1"
                                                 color="primary"
                                                 :disabled="!(!!row.item.memberId)"
                                                 @click="selectedRequester = row.item; peopleSearchDialog = false">
                                              <v-icon>mdi-plus</v-icon>
                                          </v-btn>
                                      </td>
                                  </tr>
                              </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card> 
                     </v-dialog>
                  </v-col>
              </v-row> 
            </v-col>
            </v-row>
            <v-row>
              <v-col>
              <h2>Selected Aussie *</h2>
              <v-row> 
                <v-col cols="8">
                  <v-text-field
                    hide-details
                    v-model="dogId"
                    label="Dog ID"
                    clearable
                    @click:clear="dogId = ''"
                  />
                </v-col>
                <v-col>
                <v-btn color="primary" v-on:click="loadDogInfo">Find dog</v-btn>
                </v-col>
              </v-row>  
              <v-row>
                <v-col>
                  <p class="mt-5" v-if="!!dogInfo">
                    <b>Name: </b> {{ dogInfo.name }} <br />
                    <b>ASCA ID: </b> {{ dogInfo.dogId }} <br />
                    <b>Main Color: </b> {{ dogInfo.body }} <br />
                    <b>DNA Status: </b> {{ dogInfo.dnaStatus }} <br />
                    <v-divider></v-divider>
                    <CoownersList :owners="dogInfo.owners" :ownershipType="dogOwnershipType" />
                  </p>
                </v-col>
              </v-row>
            </v-col>
            </v-row>
          </v-col>
          <v-col class="ml-5">              
              <v-row>
                <v-col>
                  <v-select
                    :items="printTypes"
                    v-model="selectedPedigreePrintType"
                    label="Print type *"
                    item-text="name"
                    item-value="id"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <v-row>                           
                <datepicker 
                  :date="submittedAt"
                  label="Submitted At"
                  v-on:updateDates="updateDates($event, 'submittedAt')"
                />
              </v-row>
              <v-row>
                <v-text-field
                  hide-details
                  v-model="adminNotes"
                  label="Admin order notes"
                  clearable
                  @click:clear="adminNotes = ''"
                /> 
              </v-row>
          </v-col>
          <v-col>    
              <h2 class="mt-5">
                Payment (${{fee}})
              </h2>              
              <v-checkbox v-model="skipPayment" label="Skip payment details"></v-checkbox>
              <v-row>
                <v-col>
                  <v-select 
                    v-if="!skipPayment"
                    :items="paymentTypes"
                    v-model="selectedPaymentType"
                    label="Payment type *"
                    item-text="name"
                    item-value="id"
                  />
                </v-col>
              </v-row>                          
                <datepicker 
                  v-if="!skipPayment"
                  :date="paidAt"
                  label="Paid At *"
                  v-on:updateDates="updateDates($event, 'paidAt')"
                />
              <v-text-field
                v-if="!skipPayment"
                v-model="paymentNotes"
                label="Payment notes"
                clearable
                @click:clear="paymentNotes = ''"
              />
          </v-col>
        </v-row>
        </v-sheet>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" v-on:click="submit">Register</v-btn>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";
import router from "@/router";

import FooterText from "@/components/common/FooterText.vue";
import Datepicker from "@/components/common/inputs/DatepickerFormatted.vue";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";

import adminService, {AdminSearchCoownersResult} from '@/services/adminService';
import registerLeaseService from "@/services/portal/registerLeaseService";
import { getPedigreePrintTypesList } from "@/services/lookupsService";
import pedigreeService from '@/services/portal/pedigreeService';
import adminPedigreeService from "@/services/admin/pedigreeService";
import { PedigreeTypes } from "@/constants";

export default Vue.extend({
  components: { FooterText, CoownersList, Datepicker, },
  name: "AdminRegisterLease",
  data: function () {
    return {
        isLoading: false,
        hasSearched: false,
        dogId: '',
        dogInfo: {
          owners: [] as any[]
        } as any,
        memberId: null,
        memberName: '',
        feesTable: {} as any,
        errorMessage: '',
        submittedAt: '',
        paidAt: '',
        adminNotes: '',
        fee: null,
        printTypes: [] as any[],
        selectedPedigreePrintType: null,
        pedigreeFees: {
          digital: {description: '', price: null},
          small: {description: '', price: null},
          large: {description: '', price: null},
          progenyDigital: {description: '', price: null},
        },        

        pedigreeTypes_digital: PedigreeTypes.PedigreeDigital,    
        pedigreeTypes_small: PedigreeTypes.PedigreeSmall,
        pedigreeTypes_large: PedigreeTypes.PedigreeLarge,
        pedigreeTypes_progenyDigital: PedigreeTypes.ProgenyDigital,

        paymentNotes: '',
        paymentTypes: [] as any[],
        selectedPaymentType: null,
        peopleSearchDialog: false,
        selectedRequester: null as any,
        searchPeopleHeaders: [
            { text: "Member ID", align: "center", value: "memberId" },
            { text: "Name", align: "center", value: "name" },
            { text: "Active member?", align: "center", value: "isActiveMember" },
            { text: "", align: "center", value: "" },

        ],
        searchPeopleResults: [] as AdminSearchCoownersResult[],
        pedigreeOrdersPath: '/admin/registration/pedigrees',   
        skipPayment: false,
    };
  },
  computed: {
    dogOwnershipType: function() {
      return OwnershipType.Dog;
    },
    leaseOwnershipType: function() {
      return OwnershipType.Lease;
    },    
    userInfo: function() {
      return this.$store.state.userInfo;
    },
    isValid: function() {
      return !!this.$data.dogId && !!this.$data.selectedRequester && !!this.$data.selectedPedigreePrintType;
    },
  },
  created() {
    this.printTypes = getPedigreePrintTypesList();
    adminService.getPaymentTypes().then((res) => {
      this.paymentTypes = res;
    });
    this.getFees();
  },
  watch: {
    selectedPedigreePrintType: function(newValue) { 
      const fee = newValue === PedigreeTypes.PedigreeDigital ? this.pedigreeFees.digital.price
                      : newValue === PedigreeTypes.PedigreeSmall ? this.pedigreeFees.small.price
                      : newValue === PedigreeTypes.PedigreeLarge ? this.pedigreeFees.large.price
                      : newValue === PedigreeTypes.ProgenyDigital ? this.pedigreeFees.progenyDigital.price
                      : 0;
      this.$data.fee = fee;
    },
    selectedRequester: function(newValue){
      if (!!newValue){
        this.$data.memberId = newValue.memberId;
        this.getFees();
      } else {
        this.$data.memberId = null;
      }
    }
  },
  methods: {
    calculateFee: function(pedigreeType: number){
      const fee = pedigreeType === PedigreeTypes.PedigreeDigital ? this.pedigreeFees.digital.price
                      : pedigreeType === PedigreeTypes.PedigreeSmall ? this.pedigreeFees.small.price
                      : pedigreeType === PedigreeTypes.PedigreeLarge ? this.pedigreeFees.large.price
                      : pedigreeType === PedigreeTypes.ProgenyDigital ? this.pedigreeFees.progenyDigital.price
                      : 0;
      this.$data.fee = fee;
    },
    updateDates: function (val: any, key: string) {
      (this as any)[key] = val.date;
    },       
    getFees: async function() {
      if(!!this.selectedRequester){
        this.pedigreeFees = await pedigreeService.getFees(this.selectedRequester.personId);
      }
    },
    submit() {
        this.$store.dispatch("changeLoaderStatus",true);
        this.errorMessage = '';
        const request = {
            adminPersonId: this.userInfo.personId,
            requesterPersonId: this.selectedRequester.personId,
            dogId: this.dogId,
            submissionDate: this.submittedAt,
            adminNotes: this.adminNotes,
            fee: this.fee,
            paymentInfo: this.skipPayment ? null : {
                paymentType: this.selectedPaymentType,
                adminNotes: this.paymentNotes,
                amount: this.fee,
                isCaptured: true,
                paidAt: this.paidAt

            } ,
            pedigreePrintType: this.selectedPedigreePrintType,
        };
        adminPedigreeService.registerPedigreeOrder(request).then((res)=>{
            if(!!res.messages){
              this.errorMessage = res.messages.join(', ');
            }

            if(res.success){
              router.push({ path: this.pedigreeOrdersPath});
            }
          })
          .finally(() => {
            this.$store.dispatch("changeLoaderStatus",false);
          })
        ;
    },
    loadDogInfo(){
        registerLeaseService.getLeasedDog(this.dogId).then((res) => {
            if(!res){
              this.errorMessage = "Dog information reuquired for lease not found.";  
              this.dogInfo = {} as any;        
            } else {
              this.dogInfo = res;
              this.errorMessage ='';
            }
        }).catch((e:any) => {
          this.errorMessage = "Dog information not found.";  
          this.dogInfo = {} as any;   
        });
    },
    findPerson() {
      this.isLoading = true;
      this.hasSearched = false;
      adminService
        .adminSearchCoowners({
          memberId: this.$data.memberId,
          nameSearchText: this.$data.memberName,
          judgeId: ''
      })
        .then((response: any) => {
          this.isLoading = false;
          this.hasSearched = true;
          this.searchPeopleResults = response;
        });
    },
  },
});
</script>